import { createMemo } from "solid-js";

export const isCatchUp = (startTime: number, rollingBufferDuration: number, currentDate?: number) => {
    const currentDateTime: number = currentDate ?? Date.now();
    const rollingTime: number = currentDateTime - (rollingBufferDuration * 60 * 60 * 1000);

    return currentDateTime > startTime && rollingTime < startTime
}